import { ChevronRightIcon } from "@heroicons/react/outline";
import React from "react";
import { useFlaggingSystem } from "ui/components/chat/flagging/container";
import Flag from "ui/components/icons/Flag";
import { CHAT_FLAGS, CHAT_FLAGS_KEYS } from "ui/lib/constants";
import { getMemberShortName } from "ui/lib/helpers";
import { ActionMenu } from "apollo/components/mobile/action-menu";

/** Add Flag as a sheet of flags, for the member info screen below lg. */
export const FlagPicker = () => {
  const { isMuted, updateActionFlag, room } = useFlaggingSystem();
  if (isMuted || !room?.id) return null;
  const name = room.user ? getMemberShortName(room.user) : room.name;

  return (
    <ActionMenu
      title={name ? `Flag ${name}` : "Add flag"}
      options={CHAT_FLAGS_KEYS.filter(
        (key) => !CHAT_FLAGS[key]?.deprecated
      ).map((value) => ({
        value,
        label: CHAT_FLAGS[value]?.label,
        selected: value === room.actionFlag,
        disabled: value === room.actionFlag,
      }))}
      onSelect={(value) => updateActionFlag({ value })}
      trigger={
        <button
          type="button"
          className="flex min-h-12 w-full items-center gap-3 rounded-xl bg-white/[0.06] px-4 text-left text-[16px] text-white/90 active:bg-white/[0.1]"
        >
          <Flag aria-hidden="true" className="size-5 text-white/60" />
          <span className="min-w-0 flex-1">Add flag</span>
          <ChevronRightIcon
            aria-hidden="true"
            className="size-5 text-faint"
          />
        </button>
      }
    />
  );
};
